import { render, staticRenderFns } from "./BillingDocumentsPreview.vue?vue&type=template&id=6d36045e&scoped=true"
import script from "./BillingDocumentsPreview.vue?vue&type=script&lang=js"
export * from "./BillingDocumentsPreview.vue?vue&type=script&lang=js"
import style0 from "./BillingDocumentsPreview.vue?vue&type=style&index=0&id=6d36045e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d36045e",
  null
  
)

export default component.exports